<template>
  <div>
    <!-- vimeo -->
    <div class="video-container" v-if="!loading">
      <vimeo-player
        ref="player"
        :video-id="videoId"
        @playing="onPlayerPlaying"
        @pause="onPlayerPause"
        @ended="onPlayerEnded"
        :options="options"
      ></vimeo-player>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
const APP_BASE_URL = process.env.VUE_APP_BASE_URL;
import { mapState } from "vuex";

export default {
  name: "Vimeo",
  data() {
    return {
      player: null,
      loading: true,
      videoId: "",
      vimeoPattern: /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/,
      options: {
        responsive: true,
        playsinline: true,
        muted: false,
        autoplay: false
      }
    };
  },
  async mounted() {
    console.log("[Vimeo] mounted", this.content);
    this.loading = true;
    const result = this.content.stream_url.match(this.vimeoPattern);
    console.log(result, result[1]);
    this.videoId = result[1];
    if (this.content.autoplay) this.options.autoplay = true;
    if (this.content.mute) this.options.muted = true;

    this.loading = false;
    console.log(this.$refs.player);
  },
  computed: {
    ...mapState(["content", "gatePass", "user"])
  },
  async beforeDestroy() {
    // 부모에서 iframe 닫을때 실행이 안되서 작동안함
    if (this.player) {
      this.player.dispose();
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    }
  },
  methods: {
    async onPlayerPause(player) {
      console.log("[VideoPlayer] player pause!", player);
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    },
    async onPlayerEnded(player) {
      console.log("[VideoPlayer] player ended!", player);
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    },
    async onPlayerPlaying(player) {
      console.log("[VideoPlayer] player Playing!", player);
      this.$store.commit("SET_VIDEO_PLAYING", true);
      // online 중임을 알림
      await this.$store.dispatch("online");
    }
  }
};
</script>

<style scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}
.video-container div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.video-container div iframe {
  width: 100%;
  height: 100%;
}
</style>
